import React, { useState } from "react";
import Slider from "react-slick";
import { IHomeSlide } from "../../types/home_slider";
import styled from "styled-components";
import { Row } from "react-bootstrap";
import { IInnerProject, ImagesEntity, ImagesEntityNested } from "../../types/inner_page";

function ProjectsSliderComponent({ pageItem, isRtl }: { pageItem: IInnerProject, isRtl: boolean }) {

    const images = Array.isArray(pageItem.attributes.projectSliderImages?.data)
    ? pageItem.attributes.projectSliderImages.data
    : []; // Default to an empty array if not an array




    const hasMultipleSlides = images.length > 1;
    const [activeIndex, setActiveIndex] = useState(0);

    const settings = {
        dots: hasMultipleSlides,
        infinite: hasMultipleSlides,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dir: isRtl ? 'rtl' : 'ltr', // Adjust direction based on prop
        rtl: isRtl,
        autoplay: hasMultipleSlides,
        arrows: false,
        beforeChange: (oldIndex: number, newIndex: number) => setActiveIndex(newIndex),
        customPaging: (i: number) => (
            <CustomDot isActive={i === activeIndex} />
        ),
        appendDots: (dots: React.ReactNode) => (
            <DotsContainer>
                <ul>{dots}</ul>
            </DotsContainer>
        ),
    };

    return (
        <Row className="tarabut-journey-widget-row">
            <div className="tarabut-journey-widget-image">
                <SliderContainer>
                    <Slider {...settings}>
                        {images.map((slideRow: ImagesEntityNested, index: number) => {
                            const imageUrl = slideRow?.attributes.url;

                            return (
                                <SlideItem key={index}>
                                    <SlideInner>
                                        {imageUrl && (
                                            <SlideImage
                                                src={`${process.env.REACT_APP_CMS}${imageUrl}`}
                                                alt="img"
                                            />
                                        )}
                                
                                    </SlideInner>
                                </SlideItem>
                            );
                        })}





                    </Slider>
                </SliderContainer>
            </div>
        </Row>
    );
}


export default ProjectsSliderComponent;

const SliderContainer = styled.div`
  .slick-dots {
    bottom: -30px !important; /* Position the dots container */

    

  }
`;

const SlideItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SlideInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f5f7; /* Customize based on UI */
  padding: 20px;
  border-radius: 12px; /* Rounded corners */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05); /* Slight scaling effect on hover */
  }
`;

const SlideImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 8px; /* Rounded corners */
  margin-bottom: 10px; /* Space below image */
`;

const SlideTitle = styled.h3`
  font-size: 1.2rem;
  color: #3a3a3a;
  text-align: center;
  margin-top: 10px;

  a {
    text-decoration: none;
    color: inherit;
  }
`;

// Dots container styling
const DotsContainer = styled.div`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 20px !important;
  z-index: 10 !important;

  ul {
    display: flex !important;
    padding: 0 !important;
  }

  li {
    list-style: none !important;
    margin: 0 5px !important;
  }
`;

const CustomDot = styled.li<{ isActive: boolean }>`
  width: 30px !important;
  height: 30px !important;
  border-radius: 50% !important;
  background-color: ${({ isActive }) => (isActive ? "#3bb54a" : "#d3d3d3")} !important;
  border: 2px solid ${({ isActive }) => (isActive ? "#3bb54a" : "#d3d3d3")} !important;
  box-shadow: ${({ isActive }) => (isActive ? "0 0 0 3px rgba(59, 181, 74, 0.3)" : "none")} !important;
  transition: background-color 0.3s ease;
  span {
    display: none !important;
  }
`;